(() => {
  'use strict';
  if (window.customimaCookiesInstalled) return;
  window.customimaCookiesInstalled = true;
  const script = document.currentScript;
  const symbol = script?.dataset.symbol;
  const spanish = document.documentElement.lang.startsWith('es');
  let opener;
  let measuredBanner;
  const resizeObserver = window.ResizeObserver ? new ResizeObserver(updateBannerSpace) : null;

  function updateBannerSpace() {
    const banner = document.getElementById('shopify-pc__banner');
    const shown = !!banner && banner.getClientRects().length > 0 && getComputedStyle(banner).visibility !== 'hidden';
    const state = shown ? 'visible' : 'hidden';
    if (document.body.dataset.customimaCookieBanner !== state) document.body.dataset.customimaCookieBanner = state;
    const height = shown ? Math.ceil(banner.getBoundingClientRect().height) + 'px' : '0px';
    if (document.documentElement.style.getPropertyValue('--customima-cookie-height') !== height) document.documentElement.style.setProperty('--customima-cookie-height', height);
  }

  function decorate() {
    const banner = document.getElementById('shopify-pc__banner');
    if (banner && !banner.dataset.customima) {
      banner.dataset.customima = '2026-10-13-bottom';
      const title = document.getElementById('shopify-pc__banner__body-title');
      if (title && symbol) {
        const image = document.createElement('img');
        image.src = symbol;
        image.alt = '';
        image.width = 36;
        image.height = 36;
        image.className = 'customima-cookie-symbol';
        title.prepend(image);
      }
      const accept = document.getElementById('shopify-pc__banner__btn-accept');
      const decline = document.getElementById('shopify-pc__banner__btn-decline');
      const configure = document.getElementById('shopify-pc__banner__btn-manage-prefs');
      if (accept && decline && configure) {
        // Move the original nodes so visual order and keyboard order agree.
        accept.parentElement.append(accept, decline, configure);
        configure.title = spanish ? 'Configurar cookies' : configure.textContent.trim();
        if (spanish) {
          configure.setAttribute('aria-label', 'Configurar cookies');
          const label = configure.querySelector('span');
          if (label) label.textContent = 'Configurar';
        }
        configure.setAttribute('aria-haspopup', 'dialog');
      }
    }
    if (banner !== measuredBanner) {
      if (measuredBanner) resizeObserver?.unobserve(measuredBanner);
      measuredBanner = banner;
      if (banner) resizeObserver?.observe(banner);
    }
    updateBannerSpace();
    const prefs = document.getElementById('shopify-pc__prefs');
    const close = document.getElementById('shopify-pc__prefs__header-close');
    if (close && spanish) close.setAttribute('aria-label', 'Cerrar');
    if (opener && (!prefs || !prefs.getClientRects().length)) {
      opener.focus();
      opener = undefined;
    }
  }

  async function openPreferences(event) {
    const link = event.target.closest('[data-customima-cookie-preferences]');
    if (!link) return;
    if (!window.privacyBanner?.showPreferences) return; // Preserve the policy-link fallback.
    event.preventDefault();
    const error = link.parentElement.querySelector('.customima-cookie-error');
    if (error) error.hidden = true;
    try {
      await window.privacyBanner.showPreferences();
      if (document.getElementById('shopify-pc__prefs')?.getClientRects().length) opener = link;
    } catch {
      if (error) error.hidden = false;
    }
  }

  document.addEventListener('click', openPreferences);
  const observer = new MutationObserver(decorate);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'open', 'class', 'hidden'] });
  decorate();
})();
